import AuthPanel from '@components/v2/layout/AuthPanel/AuthPanel';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

interface OAuthRequestExpiredProps {
  errorMessage: string;
}

const OAuthRequestExpired = ({ errorMessage }: OAuthRequestExpiredProps) => {
  const { translate } = useTranslation();

  return (
    <AuthPanel>
      <Stack sx={{ alignItems: 'center', gap: 1, textAlign: 'center' }}>
        <Typography variant="h5">{translate(LangEnum.OAUTH_REQUEST_EXPIRED_TITLE)}</Typography>
        <Typography variant="body2" color="text.secondary">
          {errorMessage}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {translate(LangEnum.OAUTH_REQUEST_EXPIRED_INSTRUCTION)}
        </Typography>
      </Stack>
    </AuthPanel>
  );
};

export default OAuthRequestExpired;
